<template>
  <div class="mod news">
    <div class="top-banner">
      <span class="about-label banner-txt-con" :style="{ left: `${left}px` }">
        {{$t('xinwenname')}}
      </span>
      <!-- <img src="@/assets/img/news.png" @load="bannerloadEvent" /> -->
    </div>
    <div class="linkBox">
      <div class="link-tab">
        <div @click="tabEvent(0, 'oneNav',-120)" class="link-btn" :class="{'link-btn-active' :btnActiveIndex == 0}">
          {{ $t('news-btn-txt1') }}</div>
        <div @click="tabEvent(1, 'twoNav',-180)" class="link-btn" :class="{'link-btn-active' :btnActiveIndex == 1}">
          {{ $t('news-btn-txt2') }}</div>
        <div @click="tabEvent(2, 'threeNav',-200)" class="link-btn" :class="{'link-btn-active' :btnActiveIndex == 2}">
          {{ $t('news-btn-txt3') }}</div>
      </div>
    </div>
    <div id="oneNav" class="zoomLeftTop">
      <div class="main-news ">
        <div class="block-2">
          <span class="title">{{ $t('news-btn-txt1') }}</span>
          <div class="list">
            <div class="row-item-0" v-for="(item, index) in listData" :key="item.title + index">
              <div class="group">
                <div class="imgbox">
                  <img class="imgtitle" :src="item.imageUrl" />
                </div>
                <span class="tag-1">{{ item.showTime || item.createDate && item.createDate.slice(0, 10)}}</span>
                <span class="desc" :class="{'en':isEn}">{{ item.title }}</span>
                <div class="view" @click="newsDetailEvent(item.id, item.newsTypeId)">
                  <span class="label cursorpointer">{{ $t('read-more') }}</span>
                  <img class="dot-2" src="@/assets/img/yuedu-right1.svg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- // 分页信息 -->
        <div class="block-3" v-if="metaListData.length > 9">
          <pagination @getNew="getPageData" :num="Math.ceil(metaListData.length / 9)"></pagination>
        </div>

      </div>
    </div>
    <div class="submain zoomCenterTop" id="twoNav">
      <div class="block-4">
        <span class="title-1">{{ $t('news-btn-txt2') }}</span>
        <div class="container-1">
          <img class="banner1" src="@/assets/img/news/images/img_22.png" />
          <img class="logo-1" src="@/assets/img/news/images/img_23.png" />
          <img class="horizontal-line-1" src="@/assets/img/news/images/img_24.png" />

          <img class="picture cursorpointer" src="@/assets/img/news/images/play.png" v-show="!isplay"
            @click="playEvent" />

          <video controls width="100%" v-show="isplay" id="newvideo" @ended="isplay = false">
            <source :src="videoUrl" type="video/mp4" width="100%" />
          </video>

        </div>
        <img class="large-icon-1" src="@/assets/img/news/images/img_30.png" />
        <span class="summary-7">{{ $t('news-video-txt') }}</span>
      </div>
    </div>
    <div class="row part-swiper" id="threeNav">
      <div class="block-5" id="news-container-swiper-box">
        <span class="caption has-zoom">{{ $t('news-btn-txt3') }}</span>
        <div id="swiper-container-box-new2">
          <div class=" swiper-container" >
          <div class="wrapper-news swiper-wrapper">
            <div class="group-item-0 swiper-slide" v-for="(item, index) in honorList" :key="item.honorName + index">
              <img class="image" :src="item.imageURL" @load="honorimgLoad" />
              <span class="summary-8">{{ item.honorName }}</span>
            </div>
            <!-- <div class="organization-wrapper">
              <img class="entry-pic" src="@/assets/img/news/images/img_34.png" />
              <span class="organization">2019雏鹰计划证书</span>
            </div> -->
          </div>
          <div class="swiper-pagination"></div>
        </div>
        </div>
        
      </div>
    </div>

  </div>
</template>
<script>

import Swiper from "swiper";
import { fetchNewsReportList, fetchHonorList } from '@/api/index'
import pagination from '@/components/pagination.vue'
import { menuFixed } from '@/utils/index'

export default {
  data () {
    return {
      videoUrl:  require("@/assets/img/kanlin.mp4"),
      btnActiveIndex: 0,
      metaListData: [],
      left: '',
      listData: [
        //   {
        //   imageUrl: require('@/assets/img/join/images/join.png'),
        //   title: '康霖生物荣获2022年度创新型中小企业称号',
        //   createDate: '2023-01-16',
        // }
      ],
      showPage: false,
      isplay: false,
      honorList: [],
      isEn: localStorage.getItem("lang") === 'EN',
    }
  },
  components: {
    pagination
  },
  methods: {
    bannerloadEvent(){
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74  - $('.top-banner').offset().left
    },
    newsDetailEvent (id, newsTypeId) {
      this.$router.push({
        name: 'newsdetail',
        query: {
          id,
          newsTypeId
        }
      })
    },
    tabEvent (index, id,num=0) {
      this.btnActiveIndex = index
      let isfixed = $('.linkBox').css('position') === 'fixed'
      let offset = index == 0 && isfixed ? 65 : 0
      if(!isfixed && index!==0){
        offset -= 65
      }
      const top = $('#' + id).offset().top - 134 + offset - num;
      console.log(top)
      $("html,body").animate({ scrollTop: top }, 500);
    },
    getListData () {
      fetchNewsReportList({
        language: localStorage.getItem('lang') || 'CN'
      }).then(({ data }) => {
        this.metaListData = data
        this.listData = data.slice(0, 9)
      })
    },
    playEvent () {
      this.isplay = true
      document.getElementById('newvideo').play()
    },
    fetchHonorListData () {
      let that = this
      fetchHonorList({
        language: localStorage.getItem('lang') || 'CN'
      }).then(res => {
        
        this.honorList = res.data || []
        if(this.honorList.length>0){
          that.$nextTick(()=>{
            this.swiperEvent()
          })
        }
        // setTimeout(() => {
          
        // })
      })
    },
    swiperEvent () {
      var swiper = new Swiper('.swiper-container', {
        direction: "horizontal",
        // initialSlide: 1,
        // slidesPerView: "auto",
        // centeredSlides: true,
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: 8000,
        speed: 600,
        loop: true,
        autoplay: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        autoplayDisableOnInteraction: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        paginationClickable: true,
      });
    },
    getPageData (num) {
      let base = num * 9
      this.listData = this.metaListData.slice(base, base + 9)
    },
    honorimgLoad () {
      $('.block-5 .image').click(function () {
        console.log('click')
        //获取图片路径
        var imgsrc = $(this).attr("src");
        console.log(imgsrc);
        var opacityBottom = '<div class="opacityBottom" style = "display:none"><img class="bigImg" src="' + imgsrc + '"></div>';
        $(document.body).append(opacityBottom);
        toBigImg();//变大函数
      });

      function toBigImg () {
        $(".opacityBottom").addClass("opacityBottom");//添加遮罩层
        $(".opacityBottom").show();
        $("html,body").addClass("none-scroll");//下层不可滑动
        $(".bigImg").addClass("bigImg");//添加图片样式
        $(".opacityBottom").click(function () {//点击关闭
          $("html,body").removeClass("none-scroll");
          $(".opacityBottom").remove();
        });
      }
    },
    onScrollSwitchTab(){
      var that = this
      window.addEventListener('scroll', function () {
        var tarElArr = [$("#oneNav"), $("#twoNav"), $("#threeNav")]
        var tarElScrollArr = [tarElArr[0].offset().top - 110, tarElArr[1].offset().top - 110, tarElArr[2].offset().top - 110] //[280, 1196, 1886, 2650]
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        console.log(scrollTop)
        if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
          that.btnActiveIndex = 0

        }
        else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
          that.btnActiveIndex = 0
        } else if (tarElScrollArr[1] < scrollTop && scrollTop <= tarElScrollArr[2]) {
          that.btnActiveIndex = 1
        } else  {
          that.btnActiveIndex = 2
        } 

        console.log('this.btnActiveIndex'+ that.btnActiveIndex)
    })
    },
  },
  mounted () {
    this.getListData()
    this.fetchHonorListData()
    menuFixed()
    setTimeout(() => {
      this.bannerloadEvent()
      this.onScrollSwitchTab()
    }, 100)
    
   

  },
}
</script>

<style lang="less">
.news{
 .swiper-pagination-bullet.swiper-pagination-bullet-active {
  background: #2DB3D0
  }


}
/*使图片在浏览器中居中显示*/
.bigImg {
  position: absolute;
  top: 50%;
  left: 50%;
  /*图片向左移动自身宽度的50%, 向上移动自身高度的50%。*/
  transform: translate(-50%, -50%);
}

/*遮罩层*/
.opacityBottom {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.8);
  z-index: 1000;
  top: 0;
  left: 0;
}

.mod .desc {
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  
  line-height: 28px;
  align-self: center;
  width: 348px;
  height: 56px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
   /*! autoprefixer: off; */   
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  margin: 10px 2px 0 0;
  &.en{
    height: 90px;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
     /*! autoprefixer: off; */   
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
}
.part-swiper{
  width: 100%;
  background-color: #f8f8f8;
}
#news-container-swiper-box{
  width: 1440px;
  margin: 0 auto;
}
</style>

<style src="./index.css" scoped/>




// WEBPACK FOOTER //
// src/view/News/index.vue